<template>
    <div class="entity-section-row">

        <div class="row page-heading mx-0">
            <div class="col-12 module_heading">
                <span class="module_icon" :class="iconClass"></span>
                <span class="module_type_name">{{mapTypeToLabel}}</span>
            </div>
        </div>

        <div class="entity-detail-row">
            <div class="row mx-0">
                <template>

                    <div class="box" v-for="(result, index) in resultsToShow">
                        <div class="thumnail-section" @click="goToEntityPage(result)">
                            <div v-if="result.thumbnailURIList && result.thumbnailURIList.length > 0">
                                <img class="thumnail-img" :src="result.thumbnailURIList[0]">
                            </div>
                            <div v-else-if="result.thumbnail">
                                <img class="thumnail-img" :src="result.thumbnail">
                            </div>
                            <div class="ic_container" v-else>
                                <div class="icon" :class="iconClass"></div>
                            </div>
                        </div>

                        <div class="title" v-if="result.streamTitle" @click="goToEntityPage(result)" :title="result.streamTitle">{{result.streamTitle}}</div>
                        <div class="title" v-else @click="goToEntityPage(result)" :title="result.title">{{result.title}}</div>

                        <div class="top-row">
                            <div class="left-field-section">
                                <b-link :disabled="result.isBookmarked" @click="bookmarkEntity(result)"><span class="module_icon icon-bookmark"></span></b-link>
                            </div>
                            <div class="right-entity-section">
                                <span class="module_icon" :class="iconClass"></span>
                                <!--
                                <b-dropdown :disabled.sync="result.isAddedToStream || !selectedStreamUuid.length || selectedStreamUuid.length < 1" class="add-item" no-caret>
                                    <template slot="button-content">
                                      <span class="fa fa-ellipsis-v"></span>
                                    </template>
                                    <b-dropdown-item @click.stop.prevent='addToStream(result)'>add to my stream</b-dropdown-item>
                                </b-dropdown>
                                -->
                            </div>
                        </div>

                    </div>

                    <div class="empty_pattern no_results" v-if="resultsToShow.length === 0">No results</div>

                </template>
            </div>

            <div class="read-more">
                <template v-if="enableShowMore">
                    <a @click="showMore()">more {{mapTypeToLabel}}</a>
                </template>
                <template v-else>
                    <a @click="prevPage" v-if="showPrev">prev</a>
                    <span v-if="showPrev && showNext"> | </span>
                    <a @click="nextPage" v-if="showNext">next</a>
                </template>
            </div>

            <div class="loading-spinner">
                <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                    <div class="text-center" style="color: #FFF">
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                    </div>
                </b-modal>
            </div>

        </div>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'exploreSearch',
  props: ['id', 'type', 'index', 'source', 'libraryList', 'major', 'minor', 'career', 'industry', 'reload'],
  components: {
  },
  data: () => {
    return {
      from: 0,
      size: 50,
      sort: [{_type: {order: 'desc'}}],
      results: [],
      userObj: JSON.parse(localStorage.getItem('userobj'))
    }
  },

  mounted () {
    this.loadExploreSearch()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'setCurrentFacet',
      'loadExploreResults',
      'loadCreateBookmarks',
      'addEntityToExploreStream',
      'loadExploreSubstreamEntities'
    ]),
    resetExploreSearch () {
      this.from = 0
      this.size = 50
      this.loadExploreSearch()
    },
    loadExploreSearch () {
      var data = {}
      data.indexList = this.index
      data.libraryList = this.libraryList
      data.payload = {
        from: this.from,
        size: this.size,
        sort: this.sort,
        _source: this.source,
        pragyaResponseUUID: '',
        query: {
          constant_score: {
            boost: 1,
            query: {
              bool: {
                minimum_should_match: '1',
                must: this.getMustQuery(),
                must_not: [],
                should: this.getShouldQuery()
              }
            }
          }
        }
      }
      this.loadExploreResults(data).then(res => {
        this.results = res
        let delay = (this.type === 'courses') ? 2500 : 1000
        setTimeout(() => {
          this.hideLoader()
        }, delay)
      })
      // let selectedStreamUuid = this.selectedStreamUuid
      // this.loadExploreSubstreamEntities({streamUuid: selectedStreamUuid})
      // this.$forceUpdate()
      // this.loadExploreResults(data).then(res => {
      //   console.log('results', res)
      //   this.results = res
      // })
      /*
      if (this.selectedStreamUuid && this.selectedStreamUuid.length > 0) {
        this.loadExploreSubstreamEntities({streamUuid: this.selectedStreamUuid}).then(response => {

        })
      }
      */
    },
    getMustQuery () {
      if (this.type === 'courses') {
        let query = []
        query.push({filtered: {filter: {or: [{terms: {owningLibraryId: this.libraryList}}]}}})
        if (this.major) {
          query.push(this.getFreeTextQueryString('DeliveryContext.title', this.major))
          query.push(this.getFreeTextQueryString('DeliveryContext.description', this.major))
        }
        if (this.minor) {
          query.push(this.getFreeTextQueryString('DeliveryContext.title', this.minor))
          query.push(this.getFreeTextQueryString('DeliveryContext.description', this.minor))
        }
        if (this.industry) {
          query.push(this.getFreeTextQueryString('DeliveryContext.title', this.industry))
          query.push(this.getFreeTextQueryString('DeliveryContext.description', this.industry))
        }
        if (this.career) {
          query.push(this.getFreeTextQueryString('DeliveryContext.title', this.career))
          query.push(this.getFreeTextQueryString('DeliveryContext.description', this.career))
        }
        query.push(this.getQueryString('DeliveryContext.courseType', 'EXTERNAL_'))
        return query
      } else {
        return [{filtered: {filter: {or: [{terms: {institutionId: [this.institutionId]}}]}}}]
      }
    },
    getShouldQuery () {
      var query = []
      if (this.type === 'courses') {
      } else {
        // Previous Eduction
        if (this.major) {
          query.push(this.getQueryString('StudentPathway.majors', this.major))
          query.push(this.getQueryString('CareerTag.tagName', this.major))
        }
        if (this.minor) {
          query.push(this.getQueryString('StudentPathway.minors', this.minor))
        }
        if (this.industry) {
          query.push(this.getQueryString('StudentPathway.postJob.industry', this.industry))
        }
        if (this.career) {
          query.push(this.getQueryString('StudentPathway.postJob.title', this.career))
          query.push(this.getQueryString('StudentPathway.postJob.pragyaTitle', this.career))
          query.push(this.getQueryString('CareerTag.tagName', this.career))
        }
        if (this.type === 'catalogs') {
          query.push(this.getQueryString('CareerTag.type', 'catalog'))
        }
      }
      return query
    },
    getFreeTextQueryString (field, query) {
      var queryString = {
        query_string: {
          default_field: field,
          fields: ['title^5', '_all'],
          query: query,
          use_dis_max: false
        }
      }
      return queryString
    },
    getQueryString (field, query) {
      var queryString = {
        query_string: {
          default_field: field,
          query: query
        }
      }
      return queryString
    },
    showMore () {
      this.setCurrentFacet(this.type)
    },
    goToEntityPage (entity) {
      if (this.type === 'streams') {
        return this.$router.push({ name: 'streamTime', params: { uuid: entity.streamId } })
      }
      if (this.type === 'catalogs') {
        return this.$router.push({ name: 'catalogDetail', params: { uuid: entity.uuid, loadDataFromServer: true } })
      }
      if (this.type === 'courses') {
        return this.$router.push({ name: 'courseDetail', params: { uuid: entity.uuid, loadDataFromServer: true } })
      }
    },
    bookmarkEntity (entity) {
      let entityBookmark = {
        'entityType': this.type,
        'entityTitle': entity.title,
        'entityUuid': entity.uuid,
        'source': 'explore',
        'userId': this.userObj.uuid,
        'institutionId': this.userObj.institutionId
      }
      this.loadCreateBookmarks(entityBookmark).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully added to bookmarks!.'
        })
      })
    },
    addToStream (entity) {
      // NOTE: Vue.js will not rebind isAddedToStream to :disabled unless we force an update
      // even though this was added in a computed property.
      console.log('adding entity to stream: ', entity)
      entity.isAddedToStream = true
      this.$forceUpdate()

      this.addEntityToExploreStream({entity: entity}).then((response) => {
        // NOTE: the following snippet ensures the course list is refreshed on AddToMyStream.vue
        this.$forceUpdate()
        console.log('reloading stream: ', this.selectedStreamUuid)
        this.loadExploreSubstreamEntities({streamUuid: this.selectedStreamUuid})
      })
    },
    isInStream (entity) {
      let isAddedToStream = false
      let substreams = this.substreams
      substreams.forEach((substream) => {
        if (substream.originUuid === entity.uuid) {
          isAddedToStream = true
        }
      })
      return isAddedToStream
    },

    prevPage () {
      let prev = (this.from - this.size)
      this.from = (prev || 0)
      this.showLoader()
      this.loadExploreSearch()
    },

    nextPage () {
      let next = (this.from + this.size)
      this.from = next
      this.showLoader()
      this.loadExploreSearch()
    },

    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },

    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    }
  },

  computed: {
    ...mapState({
      'careerResults': state => state.explore.careerResults,
      'programResults': state => state.explore.programResults,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'selectedStreamUuid': state => state.explore.selectedStreamUuid,
      'substreams': state => state.explore.substreams,
      'lastUpdatedTime': state => state.explore.lastUpdatedTime,
      'currentFacet': state => state.explore.currentFacet
    }),
    enableShowMore () {
      if (this.currentFacet === 'all') {
        if (this.results.length > 3) {
          return true
        }
      }
      return false
    },
    showNext () {
      if (this.results.length > 0) {
        let total = this.results[0].total
        let next = (this.from + this.size)
        return (next < total)
      }
      return false
    },
    showPrev () {
      if (this.results.length > 0) {
        let prev = (this.from - this.size)
        return (prev >= 0)
      }
      return false
    },
    institutionId () {
      let userObj = JSON.parse(localStorage.getItem('userobj'))
      if (userObj) {
        return userObj.institutionId
      }
      return ''
    },
    iconClass () {
      let t = this.type
      if (t === 'streams') {
        return 'icon icon-stream'
      } else if (t === 'catalogs') {
        return 'module_icon ico-catalog1'
      } else if (t === 'jobs') {
        return 'module_icon icon-job'
      } else if (t === 'person') {
        return 'module_icon ico-mentor'
      } else if (t === 'clubs') {
        return 'module_icon ico-club'
      } else if (t === 'events') {
        return 'module_icon fas fa-calendar-alt'
      } else if (t === 'courses') {
        return 'module_icon icon-course'
      }
    },
    mapTypeToLabel () {
      let t = this.type
      if (this.type === 'courses') {
        return 'external courses'
      } else if (this.type === 'catalogs') {
        return 'course catalogs'
      } else {
        return t
      }
    },
    resultsToShow () {
      if (!this.results || !this.results.length) {
        return []
      }
      /*
      let isInStream = this.isInStream
      this.results.forEach(result => {
        result.isAddedToStream = isInStream(result)
      })
      */
      if (this.currentFacet === this.type) {
        return this.results
      } else if (this.currentFacet === 'all') {
        return this.results.slice(0, 4)
      }
      return []
    }
  },

  watch: {
    id (newId) {
      if (newId) {
        this.resetExploreSearch()
      }
    },
    lastUpdatedTime (newTime) {
      // this.loadExploreSearch()
    },
    selectedStreamUuid (newId) {
      this.loadExploreSearch()
    }
  }
}
</script>
<style>
.thumnail-img{
  width: 100px!important;
}
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreSearch.vue